import { call, put, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import {
  OPEN_PLATFORM_APP_MARKET_PAGE_REQUEST,
  OPEN_PLATFORM_APP_MARKET_LIST_REQUEST,
  OPEN_PLATFORM_APP_MARKET_ON_CHANGE_FIELD,
  OPEN_PLATFORM_APP_MARKET_ON_CLICK_LEARN_MORE,
} from 'actions/openPlatform/appMarket/constants';
import * as apiMarketplaces from 'api/marketplaces';
import { showProgressBar, hideProgressBar } from 'actions';
import { initialize } from 'redux-form';
import * as actNotif from 'actions/notifications';
import * as actAppmarket from 'actions/openPlatform/appMarket';
import * as clevertapOpenPlatformAppMarket from 'clevertap/openPlatform/appMarket';

export function* pageRequestFlow(request) {
  const { payload } = request;
  let keyword = '';
  let category = '';

  if (payload !== '') {
    keyword = payload.params.searchValues.keyword;
    category = payload.params.searchValues.category;
  }

  yield put(actAppmarket.setApps({ apps: [] }));
  yield put(actAppmarket.listRequest({ params: {} }));
  yield put(
    initialize('search', {
      keyword,
      category,
    })
  );
  if (keyword.length) {
    $('#open-platform-action-bar__search')
      .focus()
      .setCursorPosition(keyword.length);
  }
}

export function* listRequestFlow(request) {
  const {
    payload: { params },
  } = request;
  if (params && params.keyword) {
    params.q = params.keyword;
    delete params.keyword;
  }
  try {
    yield put(showProgressBar());
    const response = yield call(apiMarketplaces.getMarketplaces, { params });
    yield put(actAppmarket.setApps({ apps: response.data.data.apps }));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(hideProgressBar());
  }
}

export function* onChangeFieldFlow(request) {
  const {
    payload: { searchValues },
  } = request;
  yield call(delay, 100);
  yield put(actAppmarket.setApps({ apps: [] }));
  yield put(actAppmarket.listRequest({ params: searchValues }));
  clevertapOpenPlatformAppMarket.appMarketSearchBox({ search: searchValues.q });
}

export function* onClickLearnMoreFlow(request) {
  const {
    payload: { app },
  } = request;
  yield put(actAppmarket.setAppDetail({ app }));
  yield put(actAppmarket.showDetailModal());
}

export default function* saga() {
  yield takeLatest(OPEN_PLATFORM_APP_MARKET_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(OPEN_PLATFORM_APP_MARKET_LIST_REQUEST, listRequestFlow);
  yield takeLatest(OPEN_PLATFORM_APP_MARKET_ON_CHANGE_FIELD, onChangeFieldFlow);
  yield takeLatest(
    OPEN_PLATFORM_APP_MARKET_ON_CLICK_LEARN_MORE,
    onClickLearnMoreFlow
  );
}
